import React, { Component } from 'react';
import wordsLogo from './words.png';

export default class Logo extends Component {
  render() {
    const { className } = this.props;

    return <img alt="Trouble Brewing" className={className} src={wordsLogo} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/logo/logo.jsx